/* Swym caps its shared-list images at 720px, which is too small for our cards */
(function () {
  var CONTAINER_ID = 'swym-shared-wishlist-render-container';
  var FLAG = 'kinnResized';
  var WIDTHS = [300, 400, 600, 800, 1000, 1200];
  var SIZES = '(min-width: 750px) 25vw, 50vw';
  var STOP_AFTER = 30000;

  /* Strip Shopify's _WxH crop back to the master, keeping ?v= */
  function masterUrl(raw) {
    var u = new URL(raw, window.location.href);
    if (u.hostname !== 'cdn.shopify.com') return null;
    if (!/\.(jpe?g|png|webp|gif|avif)$/i.test(u.pathname)) return null;
    u.pathname = u.pathname.replace(/_\d+x\d*(?=\.[a-z]+$)/i, '');
    u.searchParams.delete('width');
    u.searchParams.delete('height');
    u.searchParams.delete('crop');
    return u;
  }

  function at(url, width) {
    url.searchParams.set('width', String(width));
    return url.href;
  }

  function upgrade(img) {
    if (img.dataset[FLAG]) return;
    img.dataset[FLAG] = '1';
    try {
      var url = masterUrl(img.getAttribute('src') || '');
      if (!url) return;
      /* src is left alone on purpose: writing it forces a second fetch */
      img.setAttribute('sizes', SIZES);
      img.setAttribute(
        'srcset',
        WIDTHS.map(function (w) {
          return at(url, w) + ' ' + w + 'w';
        }).join(', ')
      );
    } catch (e) {
      /* leave the app's own image in place */
    }
  }

  function sweep(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('#' + CONTAINER_ID + ' img.swym-wishlist-image');
    for (var i = 0; i < imgs.length; i++) upgrade(imgs[i]);
  }

  function start() {
    sweep(document);
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('img.swym-wishlist-image')) {
            if (node.closest('#' + CONTAINER_ID)) upgrade(node);
          } else {
            sweep(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, STOP_AFTER);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
